import './link.less'
import m from 'mithril'
import {classes, Component, action, Icon} from '@codeurs/front'

type Mod =
	| 'navigation'
	| 'scaleonhover'
	| 'scaleonhover-white'
	| 'blue'
	| 'tag'
	| 'mailto'

export default class Link extends Component<{
	class?: string
	mod?: Mod | Array<Mod>
	href?: string
	[key: string]: any
}> {
	view() {
		const {class: className, mod, ...attrs} = this.attrs
		return m('a.link', {...classes(className, {mod}), ...attrs}, this.children)
	}
}
